jQuery(function ($) {
    "use strict";

    // SEARCH FORM (search-form.php)
    if ($('.pjl-form').length) {

        // Remove hash from URL so no automatic scrolling
        if (window.location.hash) {
            history.replaceState(null, '', window.location.pathname + window.location.search);
        }

        // Restore scroll position if saved, otherwise scroll to top
        var savedScroll = sessionStorage.getItem('scrollPos');
        if (savedScroll) {
            window.scrollTo(0, parseInt(savedScroll, 10));
            sessionStorage.removeItem('scrollPos');
        } else {
            setTimeout(function () {
                window.scrollTo(0, 0);
            }, 50);
        }

        var $form       = $('.pjl-form');
        var $btn        = $('.pjl-submit-button', $form);
        var $spinner    = $('.pjl-spinner', $form);
        var $label      = $('.pjl-button-label', $form);
        var $selects    = $form.find('select');

        $selects.each(function () {
            if ($(this).val()) {
                $btn.prop('disabled', false);
            }
        });

        $selects.on('change', function () {
            $btn.prop('disabled', false);
        });

        $form.on('submit', function (e) {
            e.preventDefault();

            // Save scroll position before reload
            sessionStorage.setItem('scrollPos', window.scrollY || window.pageYOffset);

            // Hide label and show spinner
            $label.addClass('hidden');
            $spinner.removeClass('hidden').addClass('visible').addClass('animate-spin');

            $btn.prop('disabled', true);

            var params = new URLSearchParams($form.serialize());
            var newUrl = window.location.pathname + '?' + params.toString();

            // Reload WITHOUT any hash
            window.location.replace(newUrl);
        });
    }

    
    // DETAIL PAGE SCROLL (detail.php)
    if ($('#apply-now').length) {

        var isApplyPath = /\/apply\/?$/i.test(location.pathname);
        var hasHash     = location.hash === '#apply-now';

        if (isApplyPath && hasHash) {
            $('html, body').animate(
                { scrollTop: $('#apply-now').offset().top },
                600
            );
        }
    }

    // APPLY FORM (apply.php)
    if ($('#new_candidate').length) {

        if (window.matchMedia('(pointer: coarse)').matches) {
            $('#candidate_resume').prop('required', false);
        }

        var $applyForm = $('#new_candidate');
        var $submitBtn = $('input[type="submit"]', $applyForm);
        var $country = $('#candidate_country');
        var $countryPhone = $('#candidate_country_phone');

        $country.change(handleCountryChange);

        $countryPhone.countrySelect({
            preferredCountries: ['us', 'br', 'ph', 'gb']
        });

        // Add custom email validator BEFORE calling $applyForm.validate()
        $.validator.addMethod("validEmail", function (value, element) {
            var emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            return this.optional(element) || emailRegex.test(value);
        }, "Please enter a valid email address (e.g., name@example.com)");

        // Single $applyForm.validate() call with all options
        var jqValidator = $applyForm.validate({
            normalizer: function (value) {
                return $.trim(value);
            },
            rules: {
                'candidate[email]': {
                    required: true,
                    validEmail: true
                }
            },
            messages: {
                'candidate[email]': 'Please enter a valid email address with proper format (name@domain.com)',
                'candidate[resume]': 'A resume is required, only the following files are accepted: .doc .pdf .zip .pages .docx .rtf or .txt',
            },
            onfocusout: function (element, event) {
                var $elem = $(element);
                if ('candidate[resume]' === $elem.attr('name')) return;
                jqValidator.element($elem);
            },
            errorPlacement: function ($label, $elem) {
                $elem.parents('div').first().append($label);
            }
        });

        $(document).on("change", "#new_candidate #candidate_resume", function () {
            $(this).valid();
        });

        $(document).on("input change", "#new_candidate input, #new_candidate select", function () {
            var isValid = $applyForm[0].checkValidity && $applyForm[0].checkValidity();
            if (isValid) isValid = jqValidator.form();
            $submitBtn.prop('disabled', !isValid);
        });

        $('#candidate_phone').blur(function () {
            jqValidator.element('#candidate_resume');
        });

        $(document).on("submit", "#new_candidate", function (e) {
            e.preventDefault();

            var form    = $(this);
            var nonce   = pjl_form.nonce;

            $.ajax({
                url: pjl_form.ajaxurl,
                type: "POST",
                data: {
                    action: "pjl_verify_nonce",
                    nonce: nonce
                },
                success: function (response) {

                    if (!response.success) {
                        alert("Security validation failed. Please refresh the page.");
                        return;
                    }

                    var t = form.find('[type="submit"]');
                    t.val("Submitting");
                    t.prop("disabled", true);

                    var data    = new FormData(form[0]);
                    data.delete('pjl_nonce');
                    var dataLog = form.serializeArray();

                    $('.pjl-question', '#new_candidate').each(function () {
                        var $question = $(this);
                        data.append('screening_questions[][id]', $question.attr('data-qid'));

                        var $answer = $('input[type="radio"]:checked', $question);
                        data.append('screening_questions[][answer]', $answer.val());

                        dataLog.push({ name: 'screening_questions[][id]', value: $question.attr('data-qid') });
                        dataLog.push({ name: 'screening_questions[][answer]', value: $answer.val() });
                    });

                    var fileInput = $('#candidate_resume')[0];
                    var fileInfo  = fileInput.files && fileInput.files.length
                        ? { name: fileInput.files[0].name, size: fileInput.files[0].size, type: fileInput.files[0].type }
                        : 'NO_FILE';

                    dataLog.push({ name: 'candidate[resume]', value: fileInfo });

                    var requestLog = {};
                    for (var i = 0; i < dataLog.length; ++i) {
                        if (0 === dataLog[i].name.indexOf('question[')) continue;
                        requestLog[dataLog[i].name] = dataLog[i].value;
                    }

                    var n = $.ajax({
                        url: form.attr("action"),
                        type: form.attr("method"),
                        mimeType: form.attr("enctype"),
                        contentType: false,
                        processData: false,
                        data: data,
                        dataType: "json",
                    });

                    n.done(function (response) {

                        if (response && response.token_url) {
                            setTimeout(function () {
                                t.val("Submitted");
                            }, 0);
                            window.location = response.token_url;
                            return;
                        }

                        $("#pjl-feedback")
                            .css('color', 'darkgreen')
                            .text("Your job application has been successfully submitted. Please check your email for next steps!");

                        document.forms["new_candidate"].reset();
                        handleCountryChange();
                        $countryPhone.countrySelect("selectCountry", "us");
                        $applyForm.hide();
                    });

                    n.fail(function (xhr, err) {

                        var msg = '';

                        try {
                            var obj = JSON.parse(xhr.responseText);
                            if (obj && obj.errors) {
                                if (isArray(obj.errors)) msg = obj.errors.join(', ');
                                else msg = obj.errors;
                            }
                        } catch (e) {}

                        if (!msg) msg = formatErrorMessage(xhr, err);

                        $("#pjl-feedback")
                            .css('color', 'darkred')
                            .text(msg);
                    });

                    n.always(function () {
                        var e = $("#new_candidate").find('[type="submit"]');
                        e.val("Submit");
                        e.prop("disabled", false);
                    });

                    function formatErrorMessage(jqXHR, exception) {
                        if (jqXHR.status === 0) {
                            return 'Not connected.\nPlease verify your network connection';
                        } else if (jqXHR.status === 404) {
                            return 'The requested page not found [404]';
                        } else if (jqXHR.status === 500) {
                            return 'Internal Server Error [500]';
                        } else if (exception === 'parsererror') {
                            return 'Requested JSON parse failed';
                        } else if (exception === 'timeout') {
                            return 'Time out error';
                        } else if (exception === 'abort') {
                            return 'Ajax request aborted';
                        } else {
                            return 'Uncaught Error:\n' + jqXHR.responseText;
                        }
                    }
                }
            });
        });

        function handleCountryChange() {
            var selector1, selector2;
            if ('US' === $country.val()) {
                selector1 = '#candidate_state';
                selector2 = '#candidate_state2';
            } else {
                selector1 = '#candidate_state2';
                selector2 = '#candidate_state';
            }
            $(selector1).prop('disabled', false).show();
            $(selector2).prop('disabled', true).hide();
        }

        function isArray(o) {
            return Object.prototype.toString.call(o) === '[object Array]';
        }


    }

});

// ERROR TEMPLATE - location change redirect
jQuery(document).on('user_zc_changed', function (e, data) {
    if (!window.gUserLocRedirecting) {
        window.gUserLocRedirecting = true;
        window.location = window.location.href.split("?")[0];
    }
});
